import { useEffect, useState } from 'react'
import axios from 'lib/axios'

const useTrainingAccess = (role: string): boolean => {
  const [allowed, setAllowed] = useState(false)
  useEffect(() => {
    if (!['special_admin', 'super_admin'].includes(role)) { setAllowed(false); return }
    let active = true
    axios.get('/trainings/access').then(() => { if (active) setAllowed(true) }).catch(() => { if (active) setAllowed(false) })
    return () => { active = false }
  }, [role])
  return allowed
}

export default useTrainingAccess
